import * as React from 'react';
import * as classNames from 'classnames';
import Avatar from '../../../Components/Avatar';

import './styles.scss';
import { Popover, PopoverInteractionKind, PopoverPosition } from '@blueprintjs/core';
import Overlay from '../../../Components/Overlay';
import Icon from '../../../Components/Icon';
import ButtonIcon from '../../../Components/ButtonIcon';

export interface IUserhubProps {
    /** Logged-in user info */
    user: {
        name: string;
        avatar: string | null;
        company: string;
        role?: string;
    } | null;
    /** Representative info */
    representative: {
        name: string;
        avatar: string | null;
        company: string;
        role?: string;
        onDiscard: () => void;
    } | null;
    /** User menu status */
    isOpen: boolean;
    /** Open user menu */
    handleOpen: () => void;
    /** Close user menu */
    handleClose: () => void;
    /** Menu to display */
    menuitems: {
        name: string;
        href?: string;
        onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
        active: boolean;
    }[];
    /** React-router link component to use instead of HTML A tag. If defined href is passed as "to" prop. */
    link?: any;
}

interface IState {
}

/**
 * Displays current language and language dropdown menu
 */
class Userhub extends React.Component<IUserhubProps, IState> {
    static displayName: string = 'Userhub';

    constructor (props: IUserhubProps) {
        super(props);
    }

    renderButton = (forMobile: boolean) => {
        let u;
        if (this.props.user) {
            u = this.props.user;
        }
        if (this.props.representative) {
            u = this.props.representative;
        }

        return u ? (
            <div className={classNames('frame-admin-userhub', {
                'desktop-hide': forMobile,
                'representing': !!this.props.representative,
            })}>
                <button onClick={(e) => {
                    e.preventDefault();
                    if (forMobile) {
                        this.props.handleOpen();
                    }
                }}>
                    <div className="inner">
                        <Avatar
                            name={u.name}
                            url={u.avatar}
                            size={30}
                        />
                        <div className="text">
                            <div className="name">{u.name}</div>
                            <div className="company">{u.company}</div>
                        </div>
                    </div>
                </button>
            </div>
        ) : null;
    };
    renderMenu = () => {
        let Link: any = 'a';
        if (this.props.link) {
            Link = this.props.link;
        }

        return (
            <div>
                {this.props.representative && (
                    <div className="frame-admin-userhub-person representing">
                        <p>Representing client user</p>
                        <div className="inner">
                            <Avatar
                                size={40}
                                name={this.props.representative.name}
                                url={this.props.representative.avatar}
                            />
                            <div className="text">
                                <div className="name">{this.props.representative.name}</div>
                                <div className="company">{this.props.representative.company}</div>
                            </div>
                            <ButtonIcon
                                icon="close"
                                intent="primary"
                                size="small"
                                onClick={this.props.representative.onDiscard}
                            />
                        </div>
                    </div>
                )}
                {this.props.user && (
                    <div className="frame-admin-userhub-person">
                        <p>Logged in as</p>
                        <div className="inner">
                            <Avatar
                                size={40}
                                name={this.props.user.name}
                                url={this.props.user.avatar}
                            />
                            <div className="text">
                                <div className="name">{this.props.user.name}</div>
                                <div className="company">{this.props.user.company}</div>
                            </div>
                        </div>
                    </div>
                )}
                <ul className="menu-mobile">
                    {this.props.menuitems.map((menuitem, index) => {
                        return (
                            <li key={index}>
                                <Link
                                    {...(this.props.link ? { to: menuitem.href } : { href: menuitem.href })}
                                    onClick={menuitem.onClick}
                                    className={menuitem.active ? 'active' : ''}
                                >
                                    {menuitem.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    render () {
        return (
            <React.Fragment>
                {this.props.user ? (
                    <React.Fragment>
                        <Popover
                            hoverCloseDelay={150}
                            hoverOpenDelay={0}
                            interactionKind={PopoverInteractionKind.HOVER}
                            minimal={true}
                            position={PopoverPosition.BOTTOM_RIGHT}
                            transitionDuration={0}
                            className="frame-admin-userhub-holder not-desktop-hide"
                            portalClassName="frame-admin-userhub-portal"
                            popoverClassName="frame-admin-userhub-popover"
                            targetClassName="frame-admin-userhub-target"
                            modifiers={{
                                offset: {
                                    offset: '0, 10',
                                },
                            }}
                        >
                            {this.renderButton(false)}
                            <div className="frame-admin-menu-drop">
                                {this.renderMenu()}
                            </div>
                        </Popover>
                        {this.renderButton(true)}
                        <Overlay
                            isOpen={this.props.isOpen}
                            doClose={this.props.handleClose}
                            layout="mainmenu"
                            zIndex={9000}
                            customHeader={(
                                <div className="menu-mobile-heading right">
                                    <button onClick={this.props.handleClose}>
                                        <Icon kind="close" width={16} height={16}/>
                                    </button>
                                </div>
                            )}
                        >
                            <div className="menu-mobile-content">
                                <ul className="menu-mobile-menu">
                                    {this.renderMenu()}
                                </ul>
                            </div>
                        </Overlay>
                    </React.Fragment>
                ) : null}
            </React.Fragment>
        );
    }
}

export default Userhub;
